
import { useTranslation } from 'react-i18next';
import { blogArticles } from '../../../mocks/blogArticles';

export default function Blog() {
  const { t } = useTranslation();
  const featuredArticle = blogArticles[0];

  return (
    <section id="blog" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-normal text-gray-900 mb-6 uppercase tracking-tight" style={{ fontFamily: 'Bebas Neue, Impact, sans-serif' }}>
            {t('blog.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-700 mx-auto mb-8"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('blog.subtitle')}
          </p>
        </div>

        {/* Featured Article */}
        <div className="max-w-3xl mx-auto mb-12 sm:mb-16">
          <a
            href={`/blog/article?id=${featuredArticle.id}`}
            className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer block"
          >
            <div className="relative w-full h-64 sm:h-80 overflow-hidden">
              <img 
                src={featuredArticle.image}
                alt={featuredArticle.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-amber-700 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase">
                  {featuredArticle.category}
                </span>
              </div>
            </div>
            
            <div className="p-6 sm:p-8">
              <h3 className="text-gray-900 font-black text-2xl sm:text-3xl mb-3 sm:mb-4 group-hover:text-amber-700 transition-colors leading-tight">
                {featuredArticle.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed mb-4 sm:mb-5">
                {featuredArticle.excerpt}
              </p>
              
              <div className="flex items-center justify-between text-sm text-gray-500">
                <div className="flex items-center gap-4 sm:gap-6">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line"></i>
                    {featuredArticle.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {featuredArticle.readTime}
                  </span>
                </div>
                <span className="flex items-center gap-2 text-amber-700 font-bold group-hover:translate-x-2 transition-transform">
                  {t('blog.readMore')}
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </div>
            </div>
          </a>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="/blog"
            className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full font-bold text-sm uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-amber-700/30 whitespace-nowrap cursor-pointer"
          >
            {t('blog.viewAll')}
          </a>
        </div>
      </div>
    </section>
  );
}
